<div class="document-upload">
  <h3 class="document-upload-headline">
    {{ 'guidedCourseCreation.document.label' | translate }}
    <app-tooltip-button
      [tooltipKey]="'tooltips.guidedCourseCreation.document'"
    ></app-tooltip-button>
  </h3>

  <div class="document-upload-actions">
    <input
      #fileInput
      id="gcc-document-upload"
      name="document"
      type="file"
      class="document-upload-input"
      [accept]="acceptedFileTypes"
      (change)="onFileSelected($event)"
    />
    <button
      type="button"
      class="document-upload-button"
      [disabled]="isUploadDisabled()"
      (click)="openFilePicker()"
    >
      <mat-icon class="size-m">cloud_upload</mat-icon>
      <span>{{ 'guidedCourseCreation.document.selectFile' | translate }}</span>
    </button>
    <span class="document-upload-formats">
      {{
        'guidedCourseCreation.document.supportedFormats'
          | translate: messageParams
      }}
    </span>
  </div>

  @if (entries().length) {
    <ul class="document-upload-files">
      @for (entry of entries(); track entry.id) {
        <li
          class="document-upload-file"
          animate.enter="expand-fade-enter"
          animate.leave="expand-fade-leave"
        >
          <div class="document-upload-file-row">
            @if (entry.state === uploadStates.UPLOADING) {
              <app-loading-spinner></app-loading-spinner>
            } @else if (entry.state === uploadStates.ERROR) {
              <mat-icon
                class="size-m document-upload-file-icon--error"
                animate.enter="fade-enter"
                >cancel</mat-icon
              >
            } @else {
              <mat-icon
                class="size-m document-upload-file-icon--success"
                animate.enter="fade-enter"
                >check_circle</mat-icon
              >
            }

            <span class="document-upload-file-name">{{ entry.file.name }}</span>

            @if (entry.state === uploadStates.UPLOADING) {
              <span class="document-upload-file-meta">
                {{ 'guidedCourseCreation.document.analysing' | translate }}
              </span>
            } @else if (entry.pageCount; as pages) {
              <span class="document-upload-file-meta">
                {{
                  'guidedCourseCreation.document.pages'
                    | translate: { count: pages }
                }}
              </span>
            }

            <button
              type="button"
              class="document-upload-file-remove"
              [attr.aria-label]="
                'guidedCourseCreation.document.removeNamed'
                  | translate: { name: entry.file.name }
              "
              [disabled]="entry.isRemoving"
              (click)="onRemove(entry)"
            >
              @if (entry.isRemoving) {
                <app-loading-spinner></app-loading-spinner>
              } @else {
                <mat-icon class="size-m">delete</mat-icon>
              }
            </button>
          </div>

          @if (entry.errorKey; as key) {
            <p class="document-upload-file-error" animate.enter="fade-enter">
              {{ key | translate: messageParams }}
            </p>
          }
        </li>
      }
    </ul>
  }

  @if (suggestedTopics().length) {
    <h4 class="document-upload-topics-headline">
      {{ 'guidedCourseCreation.document.suggestions.label' | translate }}
      <app-tooltip-button
        [tooltipKey]="'tooltips.guidedCourseCreation.documentTopics'"
      ></app-tooltip-button>
    </h4>
    <div class="document-upload-topics">
      @for (chip of topicChips(); track chip.topic) {
        <app-suggestion-chip
          [label]="chip.topic"
          [disabled]="chip.used"
          (selected)="onSelectTopic(chip.topic)"
        />
      }
    </div>
  }

  @if (showModeToggle()) {
    <div class="document-upload-mode">
      <mat-slide-toggle
        [checked]="isStrictMode()"
        (change)="onModeChange($event.checked)"
      >
        <span class="document-upload-mode-title">
          {{ 'guidedCourseCreation.document.mode.label' | translate }}
        </span>
        <span class="document-upload-mode-description">
          {{ modeDescriptionKey() | translate }}
        </span>
      </mat-slide-toggle>
    </div>
  }
</div>
